"use client";

import React from "react";
import { NextImage } from "../NextImage";
import { SearchQueryProps } from "./types";

/**
 * SearchQueryItem component displays a search query box with magnifying glass icon
 */
export const SearchQueryItem: React.FC<SearchQueryProps> = ({
  data,
  onQuestionClick,
}) => {
  return (
    <div
      data-openreplay-label="HomeQuestionCard · SearchQueryItem · div"
      className="bg-background_white_overlay5 hover:bg-background_white_overlay5 rounded-xl p-4 flex flex-col items-end h-[100px] relative cursor-pointer"
      onClick={() => onQuestionClick?.(data)}
    >
      <div className="flex-1">
        <p className=" text-content_secondary body_m line-clamp-3">
          {data?.question}
        </p>
      </div>
      <div className="absolute bottom-4 right-4">
        <NextImage
          src="/assets/images/search.svg"
          alt="search"
          width={12}
          height={12}
        />
      </div>
    </div>
  );
};
